import { createApp, defineComponent, nextTick, onMounted, reactive, ref, watch } from 'vue';
import { forms } from '../../types/front/TOrderForm';
import dayjs from 'dayjs';
import PaperSize from '../../models/PaperSize';
import PrintingMethod from '../../models/PrintingMethod';
import cart from '../_component/Cart';
import _ from 'lodash';
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
const App = defineComponent({
    setup() {
        dayjs.extend(timezone);
        dayjs.extend(utc);
        dayjs.tz.setDefault("Asia/Tokyo");
        const PAPER_PURPOSE_FLYLEAF_INDEX = 2;
        const PAPER_PURPOSE_COVER_INDEX = 0;
        const STORAGE_ORDER_SPECIFICATION = 'orders_specification';
        let orders = forms;
        let feeShipping = reactive({});
        let data = ref();
        let errors = reactive({});
        let paperSizes = reactive([new PaperSize()]);
        let printingMethods = reactive([new PrintingMethod()]);
        let arrive_at = { year: '', month: '', day: '' };
        let refForm = ref();
        let hiddenModalFlyleaf = reactive({ value: true });
        let checkRedirectLogin = null;
        let cartPlanForwarding = reactive([{}]);
        //plan coating
        let coatingDefaultCheck;
        let coatingFee = reactive([]);
        let dataCoatingFee = reactive([]);
        //plan position
        let positionFee = reactive([]);
        let dataPositionFee = reactive([]);
        let paperSizeFees = ref();
        let paperSizeFee = ref();
        let lots = ref();
        let pages = ref();
        onMounted(() => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            Object.assign(errors, JSON.parse(((_a = data.value) === null || _a === void 0 ? void 0 : _a.getAttribute('errors')) || '[]'));
            Object.assign(paperSizes, JSON.parse(((_b = data.value) === null || _b === void 0 ? void 0 : _b.getAttribute('paper-sizes')) || '[]'));
            Object.assign(printingMethods, JSON.parse(((_c = data.value) === null || _c === void 0 ? void 0 : _c.getAttribute('printing-methods')) || '[]'));
            checkRedirectLogin = parseInt(JSON.parse(((_d = data.value) === null || _d === void 0 ? void 0 : _d.getAttribute('redirect')) || '0'));
            orders = _.merge(orders, reactive(JSON.parse(((_e = data.value) === null || _e === void 0 ? void 0 : _e.getAttribute('orders')) || '[]')));
            feeShipping = reactive(JSON.parse(((_f = data.value) === null || _f === void 0 ? void 0 : _f.getAttribute('feeShipping')) || '[]'));
            coatingFee = _.merge(coatingFee, reactive(JSON.parse(((_g = data.value) === null || _g === void 0 ? void 0 : _g.getAttribute('feeCoating')) || '[]')));
            positionFee = _.merge(positionFee, reactive(JSON.parse(((_h = data.value) === null || _h === void 0 ? void 0 : _h.getAttribute('feePosition')) || '[]')));
            coatingDefaultCheck = parseInt(JSON.parse(((_j = data.value) === null || _j === void 0 ? void 0 : _j.getAttribute('coatingDefaultCheck')) || '0'));
            checkRedirectLogin = parseInt(JSON.parse(((_k = data.value) === null || _k === void 0 ? void 0 : _k.getAttribute('redirect')) || '0'));
            cartPlanForwarding = _.merge(cartPlanForwarding, reactive(JSON.parse(((_l = data.value) === null || _l === void 0 ? void 0 : _l.getAttribute('cart-plan-forwarding')) || '[]')));
            orders[0].plans[0].arrive_at = dayjs();
            hiddenModalFlyleaf.value = orders[0].plans[0].paper_purposes[PAPER_PURPOSE_FLYLEAF_INDEX].paper_positions[0].id === null;
            orders[0].payments[0].shipping = feeShipping.fee || 0;
            paperSizeFees.value = JSON.parse(((_m = data.value) === null || _m === void 0 ? void 0 : _m.getAttribute('paperSizeFee')) || '[]');
            //check redirect login
            if (checkRedirectLogin) {
                orders = _.merge(orders, reactive(getOldOrderBeforeLogin()));
                localStorage.removeItem(STORAGE_ORDER_SPECIFICATION);
                if (orders[0].plans[0].paper_purposes[PAPER_PURPOSE_FLYLEAF_INDEX].paper_positions[0].id) {
                    hiddenModalFlyleaf.value = false;
                }
                saveCartToAfterLogin();
            }
            //check forwarding
            if (cartPlanForwarding.length > 0 && Object.keys(cartPlanForwarding[0]).length > 0) {
                let data = reactive([{}]);
                cartPlanForwarding.forEach((item, index) => {
                    // @ts-ignore
                    data[index] = {
                        // @ts-ignore
                        id: item.id,
                        // @ts-ignore
                        forwarding_id: item.forwarding_id ? item.forwarding_id : (orders[0].mode == 'event' ? FORWARDING_VENUE : item.forwarding_id),
                        // @ts-ignore
                        lot: item.lot,
                        // @ts-ignore
                        arrive_at: item.arrive_at,
                        // @ts-ignore
                        options: item.options.arrive
                    };
                });
                // @ts-ignore
                orders[0].plans[0].forwardings = data;
            }
        });
        watch(() => orders[0].plans[0].paper_purposes, () => {
            orders[0].payments[0].option = 0;
            orders[0].plans[0].paper_purposes.forEach((paper_purpose) => {
                if (paper_purpose.paper_coatings) {
                    if (paper_purpose.paper_coatings[0].price)
                        orders[0].payments[0].option += paper_purpose.paper_coatings[0].price;
                }
                if (paper_purpose.paper_positions) {
                    if (paper_purpose.paper_positions[0].price)
                        orders[0].payments[0].option += paper_purpose.paper_positions[0].price;
                }
            });
        }, { deep: true });
        watch(() => orders[0].plans[0].paper_sizes[0].id, id => {
            var _a;
            orders[0].plans[0].paper_sizes[0].name = (_a = paperSizes.find((o) => {
                return o.id == id;
            })) === null || _a === void 0 ? void 0 : _a.name;
        });
        watch(() => orders[0].plans[0].printing_methods[0].id, id => {
            var _a;
            orders[0].plans[0].printing_methods[0].name = (_a = printingMethods.find((o) => {
                return o.id == id;
            })) === null || _a === void 0 ? void 0 : _a.name;
        });
        watch(() => [orders[0].payments[0].price, orders[0].payments[0].option, orders[0].payments[0].shipping], () => {
            orders[0].payments[0].total
                = Number(orders[0].payments[0].price)
                    + Number(orders[0].payments[0].option)
                    + Number(orders[0].payments[0].shipping);
        });
        // 用紙サイズ変更を検知してページ数、部数、料金テーブルを切り替え
        watch(() => [orders[0].plans[0].paper_sizes[0].id], () => {
            setPageSizeFeeMatrixData();
        });
        // 料金テーブル、ページ数、部数の切り替えを検知して値段を切り替え
        watch(() => [orders[0].plans[0].pages[0].value, orders[0].plans[0].lots[0].value], () => {
            setPrice();
        });
        watch(() => hiddenModalFlyleaf, d => {
        }, { deep: true });
        //fee coating
        watch(() => orders[0].plans[0].lots[0].value, () => {
            var _a;
            coatingFee.forEach((data, key) => {
                data.rate.forEach((item) => {
                    if (parseInt(String(item.lot)) == orders[0].plans[0].lots[0].value) {
                        if (data.fee_type == 2) {
                            dataCoatingFee[key] = 0;
                        }
                        else {
                            dataCoatingFee[key] = parseInt(String(item.rate));
                        }
                    }
                });
            });
            let coatingActive = (_a = orders[0].plans[0].paper_purposes[PAPER_PURPOSE_COVER_INDEX].paper_coatings[0].id) !== null && _a !== void 0 ? _a : 0;
            orders[0].plans[0].paper_purposes.forEach((paper_purpose) => {
                if (paper_purpose.paper_coatings) {
                    if (paper_purpose.paper_coatings[0].id && coatingActive) {
                        paper_purpose.paper_coatings[0].price = dataCoatingFee[coatingActive];
                    }
                }
            });
            //check coating default
            if (coatingDefaultCheck && orders[0].plans[0].paper_purposes[PAPER_PURPOSE_COVER_INDEX].paper_coatings[0].id === null) {
                orders[0].plans[0].paper_purposes[PAPER_PURPOSE_COVER_INDEX].paper_coatings[0].id = coatingDefaultCheck;
                orders[0].plans[0].paper_purposes[PAPER_PURPOSE_COVER_INDEX].paper_coatings[0].price = dataCoatingFee[coatingDefaultCheck];
            }
        });
        //fee position
        watch(() => orders[0].plans[0].lots[0].value, () => {
            positionFee.forEach((data, keyParent) => {
                Object.keys(data).forEach((key) => {
                    if (orders[0].plans[0].paper_purposes[PAPER_PURPOSE_FLYLEAF_INDEX].paper_types[0].id === null && dataPositionFee[keyParent] === undefined) {
                        renderOptionPositionFeeToCheck(data, key, keyParent);
                    }
                    else {
                        if (parseInt(key) === parseInt((String)(orders[0].plans[0].paper_purposes[PAPER_PURPOSE_FLYLEAF_INDEX].paper_types[0].id || 0))) {
                            renderOptionPositionFeeToCheck(data, key, keyParent);
                        }
                    }
                });
            });
            //render position free
            renderOptionPositionFee();
        });
        watch(() => orders[0].plans[0].paper_purposes[PAPER_PURPOSE_FLYLEAF_INDEX].paper_types[0].id, () => {
            positionFee.forEach((data, keyParent) => {
                Object.keys(data).forEach((key) => {
                    if (parseInt(key) === parseInt((String)(orders[0].plans[0].paper_purposes[PAPER_PURPOSE_FLYLEAF_INDEX].paper_types[0].id || 0))) {
                        renderOptionPositionFeeToCheck(data, key, keyParent);
                    }
                });
            });
            //render position free
            renderOptionPositionFee();
        });
        watch(() => orders[0].plans[0].paper_purposes[PAPER_PURPOSE_FLYLEAF_INDEX].paper_positions[0].id, () => {
            if (!orders[0].plans[0].paper_purposes[PAPER_PURPOSE_FLYLEAF_INDEX].paper_positions[0].id) {
                orders[0].plans[0].paper_purposes[PAPER_PURPOSE_FLYLEAF_INDEX].paper_types[0].id = null;
                orders[0].plans[0].paper_purposes[PAPER_PURPOSE_FLYLEAF_INDEX].paper_types[0].name = null;
            }
        });
        const renderOptionPositionFee = () => {
            var _a;
            let positionActive = (_a = orders[0].plans[0].paper_purposes[PAPER_PURPOSE_FLYLEAF_INDEX].paper_positions[0].id) !== null && _a !== void 0 ? _a : 0;
            orders[0].plans[0].paper_purposes.forEach((paper_purpose) => {
                if (paper_purpose.paper_positions) {
                    if (paper_purpose.paper_positions[0].id && positionActive) {
                        paper_purpose.paper_positions[0].price = dataPositionFee[positionActive];
                    }
                }
            });
        };
        const renderOptionPositionFeeToCheck = (data, key, keyParent) => {
            // @ts-ignore
            Object.keys(data[key]).forEach((keyType) => {
                if (keyType == orders[0].plans[0].paper_sizes[0].id) {
                    data[key][keyType].rate.forEach((itemRate) => {
                        if (parseInt(String(itemRate.lot)) == orders[0].plans[0].lots[0].value) {
                            if (data[key][keyType].fee_type == 2) {
                                dataPositionFee[keyParent] = 0;
                            }
                            else {
                                dataPositionFee[keyParent] = parseInt(String(itemRate.rate));
                            }
                        }
                    });
                }
            });
        };
        // 納品先登録画面への遷移
        const onClickForwarding = (url) => {
            // 注文データがすでにある場合(カート保存されていた)
            if (orders[0].id) {
                // 用紙設定されている場合(変更がある場合)はカートに保存する
                if ((orders[0].plans[0].paper_purposes[0].paper_types[0].id && orders[0].plans[0].paper_purposes[1].paper_types[0].id && !orders[0].plans[0].paper_purposes[2].paper_positions[0].id)
                    || (orders[0].plans[0].paper_purposes[0].paper_types[0].id && orders[0].plans[0].paper_purposes[1].paper_types[0].id && orders[0].plans[0].paper_purposes[2].paper_positions[0].id && orders[0].plans[0].paper_purposes[2].paper_types[0].id)) {
                    orders[0].path_name = 'front.forwarding.index';
                    orders[0].type = '';
                    cart.save(orders[0]).then(order => {
                        orders[0].id = order.id;
                        const form = refForm.value;
                        form.setAttribute('action', url);
                        nextTick(() => {
                            form.submit();
                        });
                    });
                }
                else {
                    const form = refForm.value;
                    form.setAttribute('action', url);
                    nextTick(() => {
                        form.submit();
                    });
                }
            }
            else {
                const form = refForm.value;
                form.setAttribute('action', url);
                nextTick(() => {
                    form.submit();
                });
            }
        };
        const onClickLot = (value) => {
            orders[0].plans[0].lots[0].value = value;
            orders[0].plans[0].forwardings[0].lot = value;
        };
        const onClickPage = (value) => {
            orders[0].plans[0].pages[0].value = value;
        };
        const onClickPaperCoating = (event, index, id, price, required = false) => {
            if (orders[0].plans[0].paper_purposes[index].paper_coatings[0].id == id) {
                if (required)
                    return; // 必須項目はcheckedを外さない
                let element = event.target;
                element.checked = false;
                orders[0].plans[0].paper_purposes[index].paper_coatings[0].id = null;
                orders[0].plans[0].paper_purposes[index].paper_coatings[0].price = 0;
            }
            else {
                orders[0].plans[0].paper_purposes[index].paper_coatings[0].id = id;
                orders[0].plans[0].paper_purposes[index].paper_coatings[0].price = price;
            }
        };
        const onClickPaperPosition = (event, index, id, price) => {
            if (orders[0].plans[0].paper_purposes[index].paper_positions[0].id == id) {
                let element = event.target;
                element.checked = false;
                orders[0].plans[0].paper_purposes[index].paper_positions[0].id = null;
                orders[0].plans[0].paper_purposes[index].paper_positions[0].price = 0;
            }
            else {
                orders[0].plans[0].paper_purposes[index].paper_positions[0].id = id;
                orders[0].plans[0].paper_purposes[index].paper_positions[0].price = price;
            }
            hiddenModalFlyleaf.value = orders[0].plans[0].paper_purposes[index].paper_positions[0].id === null;
        };
        const onClickPaperSize = (id) => {
            orders[0].plans[0].paper_sizes[0].id = id;
        };
        const onClickPaperType = (index, id, name) => {
            let e = document.createElement("textarea");
            e.innerHTML = name;
            orders[0].plans[0].paper_purposes[index].paper_types[0].id = id;
            orders[0].plans[0].paper_purposes[index].paper_types[0].name = e.value;
        };
        /**
         * 料金表の値段がクリックされた
         * @param lot
         * @param page
         * @param price
         */
        const onClickPriceTable = (lot, page, price) => {
            orders[0].plans[0].lots[0].value = lot;
            orders[0].plans[0].pages[0].value = page;
            orders[0].payments[0].price = price;
        };
        const onClickPrintingMethod = (id) => {
            orders[0].plans[0].printing_methods[0].id = id;
        };
        const onClickSaveInCart = () => {
            orders[0].path_name = 'front.specification.index';
            orders[0].type = 'save_cart';
            cart.save(orders[0]).then(order => {
                orders[0].id = order.id;
                alert('カートに保存しました');
            });
        };
        const getOldOrderBeforeLogin = () => {
            return JSON.parse(localStorage.getItem(STORAGE_ORDER_SPECIFICATION) || '[]');
        };
        const saveCartToAfterLogin = () => {
            orders[0].path_name = 'front.specification.index';
            orders[0].type = 'save_cart';
            cart.save(orders[0]).then(order => {
                orders[0].id = order.id;
                const url = new URL(location.href);
                url.searchParams.delete('redirect');
                url.searchParams.delete('to');
                history.pushState(null, '', url);
                localStorage.removeItem(STORAGE_ORDER_SPECIFICATION);
            });
        };
        const onClickSaveCartNotLogin = (url_login) => {
            orders[0].path_name = 'front.specification.index';
            orders[0].type = 'save_cart';
            localStorage.setItem(STORAGE_ORDER_SPECIFICATION, JSON.stringify(orders));
            window.location.href = url_login;
        };
        /**
         * 用紙サイズとそれに紐づくページ数、部数を更新する
         */
        const setPageSizeFeeMatrixData = () => {
            // 用紙サイズにぶら下がる料金テーブルデータ
            const paperSizeFeeValue = paperSizeFee.value = paperSizeFees.value[orders[0].plans[0].paper_sizes[0].id || ''];
            // 用紙サイズにぶら下がる部数データ(ページ数リスト用)
            pages.value = Object.keys(paperSizeFeeValue);
            let tmpPages = [];
            Object.values(paperSizeFeeValue).map(function (page) {
                tmpPages.push(Object.keys(page));
            });
            let tmpLots = tmpPages.flatMap(function (lot) {
                return lot;
            });
            // 用紙サイズにぶら下がる部数データ(部数リスト、料金テーブルヘッダ用)
            tmpLots.sort(function (a, b) {
                return a - b;
            });
            lots.value = Array.from(new Set(tmpLots));
            // 値段を更新する
            setPrice();
        };
        /**
         * 選択された用紙サイズ、ページ数、部数から値段を更新する
         */
        const setPrice = () => {
            let page = orders[0].plans[0].pages[0].value;
            let lot = orders[0].plans[0].lots[0].value;
            const paperSizeFeeVal = paperSizeFee.value;
            // 用紙サイズデータに選択されているページ数、部数が存在するか確認
            if (!Array.from(pages.value).includes(page) && !Array.from(lots.value).includes(lot)) {
                // ページ数：なし、部数：なし = 両方最小値で設定
                page = orders[0].plans[0].pages[0].value = pages.value[0];
                lot = orders[0].plans[0].lots[0].value = lots.value[0];
            }
            else if (Array.from(pages.value).includes(page) && !Array.from(lots.value).includes(lot)) {
                // ページ数：あり、部数：なし = 部数を最小値で設定
                lot = orders[0].plans[0].lots[0].value = lots.value[0];
            }
            else if (!Array.from(pages.value).includes(page) && Array.from(lots.value).includes(lot)) {
                // ページ数：なし、部数：あり = ページ数を最小値で設定
                page = orders[0].plans[0].pages[0].value = pages.value[0];
            }
            // 値段を更新
            orders[0].payments[0].price = paperSizeFeeVal[page][lot];
        };
        return {
            arrive_at,
            orders,
            data,
            errors,
            refForm,
            hiddenModalFlyleaf,
            dataCoatingFee,
            dataPositionFee,
            paperSizeFee,
            lots,
            pages,
            onClickForwarding,
            onClickLot,
            onClickPage,
            onClickPaperCoating,
            onClickPaperPosition,
            onClickPaperSize,
            onClickPaperType,
            onClickPriceTable,
            onClickPrintingMethod,
            onClickSaveInCart,
            onClickSaveCartNotLogin
        };
    }
});
window.addEventListener('DOMContentLoaded', (ev) => {
    createApp(App).mount('#app');
});
